import WifiOffIcon from "@mui/icons-material/WifiOff";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { statusesConstants, viewsConstants } from "@/constants";

export const OfflineIndicator = () => {
    const [isOffline, setIsOffline] = useState(!navigator.onLine);

    const isOfflineViewVisible = useSelector(({ offlineReducer }) => offlineReducer.isOfflineViewVisible);

    useEffect(
        () => {
            const setOnlineHandler = () => setIsOffline(false);

            const setOfflineHandler = () => setIsOffline(true);

            window.addEventListener(
                statusesConstants.online,
                setOnlineHandler,
            );

            window.addEventListener(
                statusesConstants.offline,
                setOfflineHandler,
            );

            return () => {
                window.removeEventListener(
                    statusesConstants.online,
                    setOnlineHandler,
                );

                window.removeEventListener(
                    statusesConstants.offline,
                    setOfflineHandler,
                );
            };
        },
        [],
    );

    if (!isOffline || isOfflineViewVisible) return null;

    return (
        <Box
            alignItems="center"
            bgcolor="error.main"
            bottom={0}
            color="error.contrastText" // eslint-disable-line
            display="flex"
            gap={1}
            justifyContent="center"
            left={0}
            position="fixed"
            py={1.5}
            right={0}
            width="100%"
            zIndex={9999}
        >
            <WifiOffIcon fontSize="small" />
            <Typography variant="body2">{viewsConstants.offline.indicator}</Typography>
        </Box>
    );
};
